import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFinancialProfile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3334 3.33334H15C15.4421 3.33334 15.866 3.50893 16.1786 3.82149C16.4911 4.13405 16.6667 4.55798 16.6667 5.00001V16.6667C16.6667 17.1087 16.4911 17.5326 16.1786 17.8452C15.866 18.1577 15.4421 18.3333 15 18.3333H5.00004C4.55801 18.3333 4.13409 18.1577 3.82153 17.8452C3.50897 17.5326 3.33337 17.1087 3.33337 16.6667V5.00001C3.33337 4.55798 3.50897 4.13405 3.82153 3.82149C4.13409 3.50893 4.55801 3.33334 5.00004 3.33334H6.66671M10 9.16667H13.3334M10 13.3333H13.3334M6.66671 9.16667H6.67504M6.66671 13.3333H6.67504M7.50004 1.66667H12.5C12.9603 1.66667 13.3334 2.03977 13.3334 2.50001V4.16667C13.3334 4.62691 12.9603 5.00001 12.5 5.00001H7.50004C7.0398 5.00001 6.66671 4.62691 6.66671 4.16667V2.50001C6.66671 2.03977 7.0398 1.66667 7.50004 1.66667Z",
		stroke: "",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFinancialProfile;
